import { alpha } from '@mui/material';
import Phaser from 'phaser';

const getRandomCoordinate = () => {
    const min = 100;
    const max = 600;
    return Math.floor(Math.random() * (max - min + 1) + min);
}

const POT_ITEM_X = 653;
const POT_ITEM_Y = 286;
const POT_ITEM_WIDTH = 3216;
const POT_ITEM_HEIGHT = 3236;
const POT_SCALE = 0.5;

//if hostname is http://localhost:3000/#t then enable drag
window.ENABLE_DRAG = window.location.hostname === "localhost";


const MY_PLATE_POSITION = { 
    "x": 96, 
    "y": 116, 
    scale: 0.7,
    "width": 5400, 
    "height": 3500,
    column2: 120,
    rowHeight1: 180,
};

export const levelsConfig = [
    {
        name: "KitchenScene",
        layout: [
            { media: 'counter', x: -177, y: 569 },
            { "media": "sink", "x": 102, "y": 392 ,
                "action": { type: "click", animation: { spine: "washHandsSpine", animation: "wash", timeScale: 0.7}, oneTimeOnly: false },
            },
            {
                "media": "sinkWater", "x": 120, "y": 646, scale: 0.6,alpha:0,
            },
            {
                "type": "spine", id: "washHandsSpine",
                "x": 320, "y": 565, scale: 0.3, alpha: 0,
                "atlas": "media/animations/HandWashing_v1/handWashing_v4_2/handWashing.atlas",
                "json": "media/animations/HandWashing_v1/handWashing_v4_2/handWashing.json",
                "subSectionID": ["washHands"],
                onCompleteShow: [],
                onCompleteHide: ["faucetWater.apng"],
                "action": {
                    type: "click", oneTimeOnly: false, animation: {
                        spine: "washHandsSpine",
                        animation: "wash",
                        timeScale: 0.70
                    },
                },
                // onStart: (spine, scene, animationConfig, itemConfig, clickedObject) => {
                //     console.log("onStart washHandsSpine", spine, scene, animationConfig, itemConfig, clickedObject);
                //     //find faucetWater.apng and set alpha to 1
                //     let faucetWater = scene.getObjectById("faucetWater.apng");
                //     if (faucetWater) {
                //         faucetWater.alpha = 1;
                //     }
                // },
                // onComplete: (spine, scene, animationConfig, itemConfig, clickedObject) => {
                //     console.log("onComplete washHandsSpine", spine, scene, animationConfig, itemConfig, clickedObject);
                //     let faucetWater = scene.getObjectById("faucetWater.apng");
                //     if (faucetWater) {
                //         faucetWater.alpha = ;
                //     }
                // },
            },
            {
                "media": "faucetWater.apng", "x": 292, "y": 439, scale: 0.3, alpha: 1,
            },
            { "media": "burnerOn", "x": 879, "y": 571 },
            { "media": "cuttingBoard", "x": 630, "y": 586, scale: 0.35 },
            { "media": "cookBookOpen", "x": 469, "y": 657 },
            { "media": "knife", "x": 768, "y": 583, scale: 0.5 },
            { "media": "fireExtinguisher", "x": 54, "y": 157 },
            { "media": "hooks", "x": 478, "y": 140, scale: 0.75 },
            { "media": "potEmptyHot", "x": 842, "y": 192, scale: 0.5 },
        ]
    },
    {
        name: "CookingScene",
        layout: [
            { "media": "counter", "x": 0, "y": 220, scale: 1 },//need new image due to scale


            // "viewId": 3,
            {
                "media": "carrots", "x": 288, "y": 241, fixedHeight: 200,
                label: "Carrots",
                "action": {
                    type: "click", oneTimeOnly: true, animation: {
                        spine: "choppingVeggies",
                        animation: "chop_carrots",
                        timeScale: 0.70,
                        onCompleteShow: ["pot_carrots_stage1"]
                    }
                },
                "subSectionID": "veggiesB",
            },

            // "viewId": 10,
            {
                "media": "yellowOnions", "x": 29, "y": 217, fixedHeight: 200,
                label: "Onions",
                alpha: 0,
                "subSectionID": "veggiesA",
                "fadeInOnAudioEvent": {
                    audio: "/audio/game/minestrone_base_1.mp3",
                    timeStamp: 6,
                    viewId: 10,
                }
            },
            {
                "media": "carrots", "x": 288, "y": 241, fixedHeight: 200,
                label: "Carrots",
                alpha: 0,
                "subSectionID": "veggiesA",
                "fadeInOnAudioEvent": {
                    audio: "/audio/game/minestrone_base_1.mp3",
                    timeStamp: 7,
                    viewId: 10,
                }
            },
            {
                "media": "celery", "x": 27, "y": 520, fixedHeight: 200,
                label: "Celery",
                alpha: 0,
                "subSectionID": "veggiesA",
                "fadeInOnAudioEvent": {
                    audio: "/audio/game/minestrone_base_1.mp3",
                    timeStamp: 8,
                    viewId: 10,
                }
            },
            {
                "media": "oliveOil", "x": 354, "y": 504, fixedHeight: 200,
                label: "Olive Oil",
                alpha: 0,
                "subSectionID": "veggiesA",
                "fadeInOnAudioEvent": {
                    audio: "/audio/game/minestrone_base_1.mp3",
                    timeStamp: 9,
                    viewId: 10,
                }
            },


            // "viewId": 11,
            {
                "media": "carrots", "x": 288, "y": 241, fixedHeight: 200,
                label: "Carrots",
                "action": {
                    type: "click", oneTimeOnly: true, animation: {
                        spine: "choppingVeggies",
                        animation: "chop_carrots",
                        timeScale: 0.70,
                        onCompleteShow: ["pot_carrots_stage1"]
                    }
                },
                "subSectionID": "veggiesB",
            },
            {
                "media": "yellowOnions", "x": 29, "y": 217, fixedHeight: 200,
                "action": { type: "click", animation: { spine: "choppingVeggies", animation: "chop_onions", timeScale: 0.70, onCompleteShow: ["pot_onions_stage1"] }, oneTimeOnly: true },
                label: "Onions",
                "subSectionID": "veggiesB",
            },
            {
                "media": "celery", "x": 27, "y": 520, fixedHeight: 200,
                label: "Celery",
                "action": { type: "click", animation: { spine: "choppingVeggies", animation: "chop_celery", timeScale: 0.70, onCompleteShow: ["pot_celery_stage1"] }, oneTimeOnly: true },
                "subSectionID": "veggiesB",
            },


            {
                "type": "spine", id: "spoonSpine",
                "x": 857, "y": 495, scale: 0.4, alpha: 0,
                "atlas": "media/animations/spoonSpine/spoonSpine.atlas",
                "json": "media/animations/spoonSpine/spoonSkeleton.json"
            },

            {
                "type": "spine", id: "ladelSpine",
                "x": 857, "y": 495, scale: 0.5, alpha: 0,
                "atlas": "media/animations/Final_SpineDeliverables/ladleSpine.atlas",
                "json": "media/animations/Final_SpineDeliverables/ladleSkeleton.json"
            },
            {
                "media": "spoon", "x": 283, "y": 325, "width": 283, "height": 1000, scale: 0.4,
                "subSectionID": "spoon",
                "action": {
                    type: "click", oneTimeOnly: false, animation: {
                        spine: "spoonSpine",
                        animation: "spoonStir",
                        timeScale: 0.70,
                        onCompleteShow: ["pot_carrots_stage2", "pot_onions_stage2", "pot_celery_stage2", "pot_oliveOil_stage2"],
                        onCompleteHide: ["pot_carrots_stage1", "pot_onions_stage1", "pot_celery_stage1", "pot_oliveOil_stage1"]
                    }, function: () => {

                    }
                },
            },


          {
            "media": "oliveOil", "x": 354, "y": 504, fixedHeight: 200,
            label: "Olive Oil",
            "action": { type: "click", animation: { spine: "oliveOilSpine", animation: "pour", timeScale: 0.70, onCompleteShow: ["pot_oliveOil_stage1"] }, oneTimeOnly: true },
            "subSectionID": "veggiesB",
          },

          { "media": "burner_topDown", "x": 591, "y": 250, scale: 0.5 },
          { "media": "flame_topDown", "x": 628, "y": 591, scale: 0.5 },
          { "media": "pot_topDown", "x": 571, "y": 264 },

          {
            "type": "spine", id: "oliveOilSpine",
            "x": 850, "y": 362, scale: 0.6, alpha: 0,
            "atlas": "media/animations/Final_SpineDeliverables/oliveOilSpine.atlas",
            "json": "media/animations/Final_SpineDeliverables/oliveOilSkeleton.json"
          },

          {
            "type": "spine", id: "waterSpine",
            "x": 850, "y": 362, scale: 0.6, alpha: 0,
            "atlas": "media/animations/Final_SpineDeliverables/waterSpine.atlas",
            "json": "media/animations/Final_SpineDeliverables/waterSkeleton.json"
          },

            {
                "type": "spine", id: "choppingVeggies",
                "x": 826, "y": 258, scale: 0.6, alpha: 0,
                "atlas": "media/animations/Final_SpineDeliverables/choppingSpine.atlas",
                "json": "media/animations/Final_SpineDeliverables/choppingSkeleton.json"
            },


            // { "media": "ladle", "x": 511, "y": 671, "width": 1272, "height": 1760, scale: 1 },

            // { "media": "oliveOil", "x": 571, "y": 264, "width": 4520, "height": 3900, scale: 0.5 },
            // { "media": "yellowOnions", "x": 571, "y": 264, "width": 4520, "height": 3900, scale: 0.5 },
            // { "media": "carrots", "x": 571, "y": 264, "width": 4520, "height": 3900, scale: 0.5 },
            // { "media": "celery", "x": 571, "y": 264, "width": 4520, "height": 3900, scale: 0.5 },

            //"viewId": 14,
            // bayLeaves
            // rosemary
            {
                "subSectionID": "herbs",
                "media": "bayLeaves", "x": 192, "y": 256, fixedHeight: 200,
                label: "Bay Leaves",
            },
            {
                "subSectionID": "herbs",
                "media": "rosemary", "x": 218, "y": 543, fixedHeight: 200,
                label: "Rosemary",
            },

            //"viewId": 16,
            {
                "media": "crushedTomatoes", "x": 220, "y": 336, fixedHeight: 200,
                "action": { type: "click", animation: { spine: "pourCansSpine", animation: "crushedTomatoes", timeScale: 0.70, onCompleteShow: ["pot_tomatoes"] }, oneTimeOnly: true },
                "subSectionID": "veggiesC",
                label: "Crushed Tomatoes",
                oneTimeOnly: true,
            },

            {
                "type": "spine", id: "pourCansSpine",
                "x": 914, "y": 257, scale: 0.4, alpha: 0,
                "atlas": "media/animations/Final_SpineDeliverables/pourCansSpine.atlas",
                "json": "media/animations/Final_SpineDeliverables/pourCanSkeleton.json",
                onStart: (spine, scene, animationConfig, itemConfig, clickedObject) => {
                    //A flowing type of emitter, for the pouring pasta. Can add frames to change particle type easier. 

                    //if tomato, then do nothing
                    if (animationConfig.animation === "crushedTomatoes") {
                        return;
                    }

                    // Clean up the previous emitter
                    if (scene.flowEmitter) {
                        scene.flowEmitter.destroy();
                        scene.flowEmitter = null;
                    }

                    //setup pour type; particle_cannelliniBeans, particle_limaBeans, particle_pintoBeans
                    let particleType = 'particle_cannelliniBeans';
                    if (animationConfig.animation === "pintoBeans") {
                        particleType = 'particle_pintoBeans';
                    }
                    else if (animationConfig.animation === "limaBeans") {
                        particleType = 'particle_limaBeans';
                    }

                    //make an oval shape for the emitter
                    let ellipse = new Phaser.Geom.Ellipse(906, 342, 100, 50);
                    //draw the ellipse
                    // let steamEllipse = scene.add.graphics({ fillStyle: { color: 0x0000ff } });
                    // steamEllipse.fillEllipse(ellipse.x, ellipse.y, ellipse.width, ellipse.height);
                    // steamEllipse.setInteractive(ellipse, Phaser.Geom.Ellipse.Contains);
                    // scene.input.setDraggable(steamEllipse);
                    // ellipse.depth = 2000;

                    //A flowing type of emitter, for the pouring pasta. Can add frames to change particle type easier. 
                    scene.flowEmitter = scene.add.particles(0, 0, particleType, {
                        // emitZone: { type: 'random', source: ellipse },
                        lifespan: 700,
                        speed: { min: 75, max: 150 },
                        scale: { start: 0.2, end: 0.5 },
                        gravityY: 450,
                        rotate: { min: 0, max: 360 },
                        emitting: false
                    });

                    //set the depth of the emitter to 2000
                    scene.flowEmitter.depth = 2000;

                    let offset = 16;

                    //read spine height and adjust by scale
                    let height = 0;
                    if (spine.skeleton) {
                        height = spine.skeleton.data.height * spine.scale;
                    }

                    spine.on('event', function (frameTime, eventData) {
                        scene.flowEmitter.setPosition(spine.x - offset, spine.y + height-40)//minus to adjust for the lid

                        if (eventData.data.name === "pour") {
                            scene.flowEmitter.emitting = true

                        } else {
                            //stop 
                            scene.flowEmitter.emitting = false
                        }

                        //after 1 second, stop the emitter
                        scene.time.delayedCall(500, function () {
                            scene.flowEmitter.emitting = false
                        }, [], scene);

                    }, scene);

                }
            },


            //boiling animation
            {
                "type": "spine", id: "boilingSpine",
                "x": 858, "y": 516, scale: 0.4, alpha: 0, loop: true, autoPlay: "boiling",
                "atlas": "media/animations/Final_SpineDeliverables/boiling.atlas",
                "json": "media/animations/Final_SpineDeliverables/boilingSkeleton.json",
            },

            //view veggiesC
            { 
                "media": "zucchini", "x": 78, "y": 254, fixedHeight: 200,
                "action": { type: "click", animation: { spine: "choppingVeggies", animation: "chop_zucchini", timeScale: 0.70, onCompleteShow: ["pot_zucchini"] }, oneTimeOnly: true },
                "subSectionID": "veggiesD",
                label: "Zucchini",
            },
            { 
                "media": "cabbage", "x": 329, "y": 247, fixedHeight: 200,
                "action": { type: "click", animation: { spine: "choppingVeggies", animation: "chop_cabbage", timeScale: 0.70, onCompleteShow: ["pot_cabbage"] }, oneTimeOnly: true },
                "subSectionID": "veggiesD",
                label: "Cabbage",
            },
            { 
                "media": "greenBeans_new", "x": 78, "y": 540, fixedHeight: 150,
                "action": { type: "click", animation: { spine: "choppingVeggies", animation: "chop_greenBeans", timeScale: 0.70, onCompleteShow: ["pot_greenBeans"] }, oneTimeOnly: true },
                "subSectionID": "veggiesD",
                label: "Green Beans",
            },

            //liquid - "Water, Salt, Pepper. Animate ingredients getting added to the pot.


            {
              "media": "waterContainer", "x": 59, "y": 242, fixedHeight: 200,
              label: "Water",
              "action": {
                type: "click", animation: { spine: "waterSpine", animation: "pour", timeScale: 0.70, onCompleteShow: ["pot_water1"] },
                oneTimeOnly: true },
              "subSectionID": "liquid",
            },
            {
                "media": "salt", "x": 395, "y": 334, "width": 760, "height": 1552, scale: 0.5,
                label: "Salt",
                "action": { type: "click", animation: { spine: "sprinkleSpine", animation: "sprinkle_salt", timeScale: 1 }, oneTimeOnly: true },
                "subSectionID": "liquid",
                oneTimeOnly: true,
            },
            {
                "media": "pepper", "x": 253, "y": 445, "width": 760, "height": 1552, scale: 0.5,
                label: "Pepper",
                "action": { type: "click", animation: { spine: "sprinkleSpine", animation: "sprinkle_pepper", timeScale: 1 }, oneTimeOnly: true },
                "subSectionID": "liquid",
                oneTimeOnly: true,
            },
            {
                "type": "spine", id: "sprinkleSpine",
                "x": 914, "y": 257, scale: 0.4, alpha: 0,//sprinkle_salt,sprinkle_pepper,sprinkle_parmesanCheese
                "atlas": "media/animations/Final_SpineDeliverables/sprinkleSpine.atlas",
                "json": "media/animations/Final_SpineDeliverables/sprinkleSkeleton.json",
                onStart: (spine, scene, animationConfig, itemConfig, clickedObject) => {
                    //A flowing type of emitter, for the pouring pasta. Can add frames to change particle type easier. 

                    // Clean up the previous emitter
                    if (scene.saltPepperEmitter) {
                        scene.saltPepperEmitter.destroy();
                        scene.saltPepperEmitter = null;
                    }

                    let emitAmount = 25;
                    let particleType = 'particle_salt';
                    if (animationConfig.animation === "sprinkle_pepper") {
                        particleType = 'particle_pepper';
                    }else if(animationConfig.animation === "sprinkle_parmesanCheese"){
                        particleType = 'particle_cheese';
                        emitAmount = 100;
                    }

                    scene.saltPepperEmitter = scene.add.particles(400, 250, particleType, {
                        lifespan: 1200,
                        speed: { min: 75, max: 150 },
                        scale: { start: 0.2, end: 0.1 },
                        alpha: { start: 1, end: 0 },
                        gravityY: 450,
                        emitting: false
                    });

                    spine.on('event', function (frameTime, eventData) {
                        var offset = 16 //Just for the salt, can adjust accordingly per animation if need be.
                        scene.saltPepperEmitter.setPosition(spine.x - offset, spine.y - offset)
                        scene.saltPepperEmitter.explode(emitAmount);
                    });
                }
            },

            //protein
            {
                "media": "cannelliniBeans", "x": 103, "y": 245, "width": 1312, "height": 1752, scale: 0.4,
                "action": { type: "click", animation: { spine: "pourCansSpine", animation: "cannelliniBeans", timeScale: 0.70, onCompleteShow: ["pot_cannelliniBeans"] }, oneTimeOnly: true },
                "subSectionID": "protein",
                label: "Cannellini Beans",
            },
            {
                "media": "pintoBeans", "x": 368, "y": 245, "width": 1312, "height": 1752, scale: 0.4,
                "action": { type: "click", animation: { spine: "pourCansSpine", animation: "pintoBeans", timeScale: 0.70, onCompleteShow: ["pot_pintoBeans"] }, oneTimeOnly: true },
                "subSectionID": "protein",
                label: "Pinto Beans",
                oneTimeOnly: true,
            },
            {
                "media": "limaBeans", "x": 103, "y": 526, "width": 1312, "height": 1752, scale: 0.4,
                "action": { type: "click", animation: { spine: "pourCansSpine", animation: "limaBeans", timeScale: 0.70, onCompleteShow: ["pot_limaBeans"] }, oneTimeOnly: true },
                "subSectionID": "protein",
                label: "Lima Beans",
            },

            // grain, Ditalini, Macaroni, Shells
            {
                "media": "pastaDitalini", "x": 103, "y": 235, "width": 1708, "height": 1816, "scale":0.4,
                "action": { type: "click", animation: { spine: "pastaSpine", animation: "pasta_ditalini", timeScale: 0.70, onCompleteShow: ["pot_pastaDitalini"] }, oneTimeOnly: true },
                label: "Ditalini",
                "subSectionID": "grain",
            },
            {
                "media": "pastaMacaroni", "x": 334, "y": 224, "width": 1248, "height": 2152, "scale":0.4,
                "action": { type: "click", animation: { spine: "pastaSpine", animation: "pasta_macaroni", timeScale: 0.70, onCompleteShow: ["pot_pastaMacaroni"] }, oneTimeOnly: true },
                label: "Macaroni",
                "subSectionID": "grain",
                oneTimeOnly: true,
            },
            {
                "media": "pastaShells", "x": 103, "y": 516, "width": 1840, "height": 2176, "scale":0.4,
                "action": { type: "click", animation: { spine: "pastaSpine", animation: "pasta_shells", timeScale: 0.70, onCompleteShow: ["pot_pastaShells"] }, oneTimeOnly: true },
                label: "Shells",
                "subSectionID": "grain",
                oneTimeOnly: true,
            },
            {
                "type": "spine", id: "pastaSpine",
                "x": 890, "y": 306, scale: 0.4, alpha: 0,//pasta_shells,pasta_macaroni,pasta_ditalini
                "atlas": "media/animations/Final_SpineDeliverables/pastaSpine.atlas",
                "json": "media/animations/Final_SpineDeliverables/pastaSkeleton.json",
                onStart: (spine, scene, animationConfig, itemConfig, clickedObject) => {
                    //A flowing type of emitter, for the pouring pasta. Can add frames to change particle type easier. 

                    //if tomato, then do nothing
                    if (animationConfig.animation === "crushedTomatoes") {
                        return;
                    }

                    // Clean up the previous emitter
                    if (scene.flowEmitterPasta) {
                        scene.flowEmitterPasta.destroy();
                        scene.flowEmitterPasta = null;
                    }

                    //setup pour type; particle_cannelliniBeans, particle_limaBeans, particle_pintoBeans
                    let particleType = 'particle_pastaMacaroni';
                    if (animationConfig.animation === "pasta_ditalini") {
                        particleType = 'particle_pastaDitalini';
                    }
                    else if (animationConfig.animation === "pasta_shells") {
                        particleType = 'particle_pastaShells1';
                    }

                    //make an oval shape for the emitter
                    // let ellipse = new Phaser.Geom.Ellipse(906, 342, 100, 50);
                    //draw the ellipse
                    // let steamEllipse = scene.add.graphics({ fillStyle: { color: 0x0000ff } });
                    // steamEllipse.fillEllipse(ellipse.x, ellipse.y, ellipse.width, ellipse.height);
                    // steamEllipse.setInteractive(ellipse, Phaser.Geom.Ellipse.Contains);
                    // scene.input.setDraggable(steamEllipse);
                    // ellipse.depth = 2000;

                    //A flowing type of emitter, for the pouring pasta. Can add frames to change particle type easier. 
                    scene.flowEmitterPasta = scene.add.particles(0, 0, particleType, {
                        // emitZone: { type: 'random', source: ellipse },
                        lifespan: 700,
                        speed: { min: 75, max: 150 },
                        scale: { start: 0.2, end: 0.5 },
                        gravityY: 450,
                        rotate: { min: 0, max: 360 },
                        emitting: false
                    });

                    //set the depth of the emitter to 2000
                    scene.flowEmitterPasta.depth = 2000;

                    let offset = 5;

                    //read spine height and adjust by scale
                    let height = 0;
                    if (spine.skeleton) {
                        height = spine.skeleton.data.height * spine.scale;
                    }

                    spine.on('event', function (frameTime, eventData) {
                        scene.flowEmitterPasta.setPosition(spine.x - offset, spine.y + height - 180)//minus to adjust for the lid

                        if (eventData.data.name === "startPasta") {
                            scene.flowEmitterPasta.emitting = true

                        } else {
                            //stop 
                            scene.flowEmitterPasta.emitting = false
                        }

                    }, scene);

                }
            },

            // toppings, Parmesan
            {
                "media": "parmesanCheese", "x": 283, "y": 440, "width": 792, "height": 1476,scale:0.5,
                "action": { type: "click", animation: { spine: "sprinkleSpine", animation: "sprinkle_parmesanCheese", timeScale: 1, onCompleteShow: ["pot_parmesanCheese"] }, oneTimeOnly: true },
                label: "Parmesan Cheese",
                "subSectionID": "toppings"
                //
            },
            // {
            //     "media": "soupMinestrone", "x": getRandomCoordinate(), "y": getRandomCoordinate(), "width": 200, "height": 200,
            //     "subSectionID": "toppings"
            // },

            // review, Soup Ladle, Bowl. Animate Soup Ladle dipping in soup and filling bowl.



            {
                "type": "spine", id: "bowlSpine",
                "x": 306, "y": 708, scale: 0.5, alpha: 0,
                "playDefault": "bowlEmpty",
                "atlas": "media/animations/Final_SpineDeliverables/bowlSpine.atlas",
                "json": "media/animations/Final_SpineDeliverables/bowlSkeleton.json",
                "subSectionID": ["reviewA","reviewB"],
            },


            // {
            //     "media": "ladle", "x": 85, "y": 266, "width": 1272, "height": 1760,scale:0.5,
            //     "subSectionID": "review",
            //     "action": {
            //         type: "click", oneTimeOnly: false, animation: {
            //             spine: "ladelSpinePour",
            //             animation: "ladlePour",
            //             timeScale: 0.70,
            //         }, function: () => {
            //             //play the bowlSpine bowlFilling animation
            //             // let bowlSpine = this.scene.getObjectById("bowlSpine");
            //             // if (bowlSpine) {
            //             //     bowlSpine.play("bowlFilling", false);
            //             // }
            //         }
            //     },
            // },
            {
                "type": "spine", id: "ladelSpinePour",
                "x": 256, "y": 603, scale: 0.5, alpha: 0,
                "atlas": "media/animations/Final_SpineDeliverables/ladleSpine.atlas",
                "json": "media/animations/Final_SpineDeliverables/ladleSkeleton.json",
                "subSectionID": ["reviewA", "reviewB"],
            },

            { alpha: 0, "media": "pot_onions_stage1", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            { alpha: 0, "media": "pot_carrots_stage1", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            { alpha: 0, "media": "pot_celery_stage1", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            { alpha: 0, "media": "pot_oliveOil_stage1", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },

            { alpha: 0, "media": "pot_onions_stage2", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            { alpha: 0, "media": "pot_carrots_stage2", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            { alpha: 0, "media": "pot_celery_stage2", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            { alpha: 0, "media": "pot_oliveOil_stage2", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },

            { alpha: 0, "media": "pot_bayLeaves", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            { alpha: 0, "media": "pot_stage6_mainBottom", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            { alpha: 0, "media": "pot_rosemary", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            { alpha: 0, "media": "pot_stage6_mainBottom", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            { alpha: 0, displayAlpha: 0.7, "media": "pot_tomatoes", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },

            { alpha: 0, "media": "pot_cabbage", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            { alpha: 0, "media": "pot_zucchini", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            { alpha: 0, "media": "pot_greenBeans", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },

            { alpha: 0, "media": "pot_water1", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE ,
                "hideOnSubSection": ["grain","toppings","reviewA", "reviewB"],
            },
            
            
            { alpha: 0, "media": "pot_cannelliniBeans", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            { alpha: 0, "media": "pot_limaBeans", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            { alpha: 0, "media": "pot_pintoBeans", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            
            {
                alpha: 0, "media": "pot_water2", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE,
                "hideOnSubSection": ["grain", "toppings", "reviewA", "reviewB"]
            },

            { alpha: 0, "media": "pot_pastaDitalini", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            { alpha: 0, "media": "pot_pastaMacaroni", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
            { alpha: 0, "media": "pot_pastaShells", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },

            

            { alpha: 1, "media": "pot_water", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE,
                "subSectionID": ["toppings","reviewA", "reviewB"],
            },

            { alpha: 0, "media": "pot_parmesanCheese", "x": POT_ITEM_X, "y": POT_ITEM_Y, "width": POT_ITEM_WIDTH, "height": POT_ITEM_HEIGHT, scale: POT_SCALE },
        ]
    },
    {
        name: "MyPlateScene",

        layout: [
            { "media": "myplatewood_background", "x": -17, "y": -12 },
            { media: 'counter', x: -177, y: 569 },

            

            //plate text
            { "media": "myplate_notext", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y,
                "subSectionID": ["produceA", "produceB"]
            },
            {
                "media": "myplate_notext_grains", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y,
                "subSectionID": ["grainsA", "grainsB"]
            },
            {
                "media": "myplate_notext_protein", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y,
                "subSectionID": ["proteinA", "proteinB"]
            },
            {
                "media": "myplate_notext_dairy", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y,
                "subSectionID": ["myplateIntro", "dairyA", "dairyB","myPlateEND"]
            },
            //plate text
            { "media": "tx_dairy_text", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, "subSectionID": null },
            { "media": "tx_fruit_text", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, "subSectionID": null },
            { "media": "tx_grains_text", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, "subSectionID": null },
            { "media": "tx_protein_text", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, "subSectionID": null },
            { "media": "tx_veggies_text", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, "subSectionID": null },

            //produce: fruits & veggies
            { "media": "fv_cabbage_plate", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, initHidden: true },
            { "media": "fv_carrots_plate", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, initHidden: true },
            { "media": "fv_celery_plate", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, initHidden: true },
            { "media": "fv_greenbeans_plate", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, initHidden: true },
            { "media": "fv_tomato_plate", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, initHidden: true },
            { "media": "fv_yellowOnions_plate", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, initHidden: true },
            { "media": "fv_zucchini_plate", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, initHidden: true },

            //grains
            { "media": "gr_ditalini_plate", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, initHidden: true },
            { "media": "gr_macaroni_plate", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, initHidden: true },
            { "media": "gr_shells_plate", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, initHidden: true },

            //proteins
            { "media": "pr_cannellinibeans_plate", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, "width": 5400, "height": 3500, initHidden: true },
            { "media": "pr_lima_beans_plate", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, "width": 5400, "height": 3500, initHidden: true },
            { "media": "pr_pintobeans_plate", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, "width": 5400, "height": 3500, initHidden: true },

            //dairy
            { "media": "dr_dairy_plate", "x": MY_PLATE_POSITION.x, "y": MY_PLATE_POSITION.y, "width": 5400, "height": 3500, initHidden: true },
            
            
            // START produce
            {
                "media": "zucchini", "x": 61, "y": 130, fixedHeight: 80,
                "label": "Zucchini",
                "action": [{ type: "click", show: ['fv_zucchini_plate'], oneTimeOnly: true }, { type: "click", hide: ['tx_veggies_text','tx_fruit_text'] }],
                "subSectionID": ["produceA", "produceB"],
            },
            {
                "media": "cabbage", "x": 61 + MY_PLATE_POSITION.column2, "y": 130, fixedHeight: 80,
                "label": "Cabbage",
                "action": [{ type: "click", show: ['fv_cabbage_plate'], oneTimeOnly: true }, { type: "click", hide: ['tx_veggies_text','tx_fruit_text'] }],
                "subSectionID": ["produceA", "produceB"]
            },

            {
                "media": "celery", "x": 61, "y": 130 + MY_PLATE_POSITION.rowHeight1 * 1, fixedHeight: 80,
                "label": "Celery",
                "action": [{ type: "click", show: ['fv_celery_plate'], oneTimeOnly: true }, { type: "click", hide: ['tx_veggies_text', 'tx_fruit_text'] }],
                "subSectionID": ["produceA", "produceB"]
            },
            {
                "media": "sliced_tomatoes", "x": 61 + MY_PLATE_POSITION.column2, "y": 130 + MY_PLATE_POSITION.rowHeight1 * 1, fixedHeight: 80,
                "label": "Tomatoes",
                "action": [{ type: "click", show: ['fv_tomato_plate'], oneTimeOnly: true }, { type: "click", hide: ['tx_veggies_text', 'tx_fruit_text'], oneTimeOnly: true}],
                "subSectionID": ["produceA", "produceB"]
            },
            {
                "media": "yellowOnions", "x": 61, "y": 130 + MY_PLATE_POSITION.rowHeight1 * 2, fixedHeight: 80,
                "label": "Onions",
                "action": [{ type: "click", show: ['fv_yellowOnions_plate'], oneTimeOnly: true }, { type: "click", hide: ['tx_veggies_text','tx_fruit_text'] }],
                "subSectionID": ["produceA", "produceB"]
            },
            {
                "media": "carrots", "x": 61 + MY_PLATE_POSITION.column2, "y": 130 + MY_PLATE_POSITION.rowHeight1 * 2, fixedHeight: 80,
                "label": "Carrots",
                "action": [{ type: "click", show: ['fv_carrots_plate'], oneTimeOnly: true }, { type: "click", hide: ['tx_veggies_text','tx_fruit_text'] }],
                "subSectionID": ["produceA", "produceB"]
            },
            {
                "media": "greenBeans_new", "x": 61, "y": 130 + MY_PLATE_POSITION.rowHeight1 * 3, fixedHeight: 80,
                "label": "Green Beans",
                "action": [{ type: "click", show: ['fv_greenbeans_plate'], oneTimeOnly: true }, { type: "click", hide: ['tx_veggies_text', 'tx_fruit_text'] }],
                "subSectionID": ["produceA", "produceB"]
            },
            
            // END produce

            //START grains
            {
                "media": "pastaDitalini", "x": 61, "y": 130, "scale":0.3,
                "label": "Ditalini",
                "action": [{ type: "click", show: ['gr_ditalini_plate'], oneTimeOnly: true }, { type: "click", hide: ['tx_grains_text'] }],
                "subSectionID": ["grainsA", "grainsB"]
            },
            {
                "media": "pastaMacaroni", "x": 61, "y": 340, "scale":0.3,
                "label": "Macaroni",
                "action": [{ type: "click", show: ['gr_macaroni_plate'], oneTimeOnly: true }, { type: "click", hide: ['tx_grains_text'] }],
                "subSectionID": ["grainsA", "grainsB"]
            },
            {
                "media": "pastaShells", "x": 61, "y": 580, "scale":0.25,
                "label": "Shells",
                "action": [{ type: "click", show: ['gr_shells_plate'], oneTimeOnly: true }, { type: "click", hide: ['tx_grains_text'] }],
                "subSectionID": ["grainsA", "grainsB"]
            },
            //END grains

            //START protein
            {
                "media": "cannelliniBeans", "x": 61, "y": 130, scale: 0.3,
                "label": "Cannellini Beans",
                "action": [{ type: "click", show: ['pr_cannellinibeans_plate'], oneTimeOnly: true }, {type: "click", hide: ['tx_protein_text']}],
                "subSectionID": ["proteinA","proteinB"]
            },
            {
                "media": "pintoBeans", "x": 61, "y": 340, scale: 0.3,
                "label": "Pinto Beans",
                "action": [{ type: "click", show: ['pr_pintobeans_plate'], oneTimeOnly: true }, {type: "click", hide: ['tx_protein_text']}],
                "subSectionID": ["proteinA","proteinB"]
            },
            {
                "media": "limaBeans", "x": 61, "y": 550, scale: 0.3,
                "label": "Lima Beans",
                "action": [{ type: "click", show: ['pr_lima_beans_plate'], oneTimeOnly: true }, {type: "click", hide: ['tx_protein_text']}],
                "subSectionID": ["proteinA","proteinB"]
            },
            //END protein

            //START dairy
            // toppings, Parmesan
            {
                "media": "parmesanCheese", "x": 91, "y": 130, "width": 792, "height": 1476, scale: 0.4,
                "label": "Parmesan Cheese",
                "action": [{ type: "click", show: ['dr_dairy_plate'], oneTimeOnly: true }, {type: "click", hide: ['tx_dairy_text']}],
                "subSectionID": ["dairyA","dairyB"]
                //
            },
            //END dairy

            //START review

            //END review
            
        ]
    },
];

export const gameAssets = {
    "media": {
        "audio": {
        },
        "images": {
            "smoke": "media/game/smoke.png",
            "sink": "media/game/sink.png",
            "sinkWater": "media/animations/HandWashing_v1/sinkAndWater_frames/poolWater.png",
            "faucetWater.apng": "media/animations/HandWashing_v1/sinkAndWater_frames/sink_water_animated.apng",
            "bgPattern": "media/game/bgPattern.png",
            "burnerOn": "media/game/burner_on.png",
            "cookBookOpen": "media/game/cookBook_open.png",
            "counter": "media/game/counter5.jpg",
            "cuttingBoard": "media/game/cuttingBoard.png",
            "fireExtinguisher": "media/game/fireExtinguisher.png",
            "hooks": "media/game/hooks.png",
            "potEmptyHot": "media/game/pot_empty_hot@2x.png",
            "knife": "media/game/knife.png",

            
            "burner_topDown": "media/game/topDown_assets/stove_topDown.png",
            "flame_topDown": "media/game/topDown_assets/flame_topDown.png",
            "pot_bayLeaves": "media/game/topDown_assets/pot_bayLeaves.png",
            "pot_cabbage": "media/game/topDown_assets/pot_cabbage.png",
            "pot_cannelliniBeans": "media/game/topDown_assets/pot_cannelliniBeans.png",
            "pot_carrots_stage1": "media/game/topDown_assets/pot_carrots_stage1.png",
            "pot_carrots_stage2": "media/game/topDown_assets/pot_carrots_stage2.png",
            "pot_celery_stage1": "media/game/topDown_assets/pot_celery_stage1.png",
            "pot_celery_stage2": "media/game/topDown_assets/pot_celery_stage2.png",
            "pot_greenBeans": "media/game/topDown_assets/pot_greenBeans.png",
            "pot_limaBeans": "media/game/topDown_assets/pot_limaBeans.png",
            "pot_oliveOil_stage1": "media/game/topDown_assets/pot_oliveOil_stage1.png",
            "pot_oliveOil_stage2": "media/game/topDown_assets/pot_oliveOil_stage2.png",
            "pot_onions_stage1": "media/game/topDown_assets/pot_onions_stage1.png",
            "pot_onions_stage2": "media/game/topDown_assets/pot_onions_stage2.png",
            "pot_parmesanCheese": "media/game/topDown_assets/pot_parmesanCheese.png",
            "pot_pastaDitalini": "media/game/topDown_assets/pot_pastaDitalini.png",
            "pot_pastaMacaroni": "media/game/topDown_assets/pot_pastaMacaroni.png",
            "pot_pastaShells": "media/game/topDown_assets/pot_pastaShells.png",
            "pot_pintoBeans": "media/game/topDown_assets/pot_pintoBeans.png",
            "pot_rosemary": "media/game/topDown_assets/pot_rosemary.png",
            "pot_stage6_mainBottom": "media/game/topDown_assets/pot_stage6_mainBottom.png",
            "pot_tomatoes": "media/game/topDown_assets/pot_tomatoes.png",
            "pot_topDown": "media/game/topDown_assets/pot_topDown_halfsize.png",
            "pot_water1": "media/game/topDown_assets/pot_water.png",
            "pot_water2": "media/game/topDown_assets/pot_water.png",
            "pot_water": "media/game/topDown_assets/pot_water.png",
            "pot_zucchini": "media/game/topDown_assets/pot_zucchini.png",

            "bayLeaves": "media/game/bayLeaves.png",
            "burner_off": "media/game/burner_off.png",
            "burner_on": "media/game/burner_on.png",
            "cabbage": "media/game/cabbage.png",
            "cannelliniBeans": "media/game/cannelliniBeans.png",
            "limaBeans": "media/game/cannelliniBeans.png",
            "carrots": "media/game/carrots.png",
            "celery": "media/game/celery.png",
            "crushedTomatoes": "media/game/crushedTomatoes.png",
            "cupMilk": "media/game/cupMilk.png",
            "fire1": "media/game/fire1.png",
            "fork": "media/game/fork.png",
            "greenBeans_new": "media/game/greenBeans_new.png",
            "ladle": "media/game/ladle.png",
            "spoon": "media/game/spoon.png",
            "magnetWithKnives": "media/game/magnetWithKnives.png",
            "waterContainer": "media/game/waterContainer.png",
            "oliveOil": "media/game/oliveOil.png",
            "parmesanCheese": "media/game/parmesanCheese.png",
            "pastaDitalini": "media/game/pastaDitalini.png",
            "pastaMacaroni": "media/game/pastaMacaroni.png",
            "pastaShells": "media/game/pastaShells.png",
            "pepper": "media/game/pepper.png",
            "pintoBeans": "media/game/pintoBeans.png",
            "plate": "media/game/plate.png",
            "pot_empty": "media/game/pot_empty.png",
            "pot_empty_hot": "media/game/pot_empty_hot.png",
            "rosemary": "media/game/rosemary.png",
            "salt": "media/game/salt.png",
            "soupMinestrone": "media/game/soupMinestrone.png",
            "stoveOn": "media/game/stoveOn.png",
            "tomatoes": "media/game/tomatoes.png",
            "sliced_tomatoes": "media/game/sliced_tomatoes.png",
            "yellowOnions": "media/game/yellowOnions.png",
            "zucchini": "media/game/zucchini.png",
            "myplate_zucchini": "media/game/zucchini.png",

            "particle_cannelliniBeans": "media/animations/ParticlesAndSpritesheets/particle_cannelliniBeans.png",
            "particle_cheese": "media/animations/ParticlesAndSpritesheets/particle_cheese.png",
            "particle_limaBeans": "media/animations/ParticlesAndSpritesheets/particle_limaBeans.png",
            "particle_pastaDitalini": "media/animations/ParticlesAndSpritesheets/particle_pastaDitalini.png",
            "particle_pastaMacaroni": "media/animations/ParticlesAndSpritesheets/particle_pastaMacaroni.png",
            "particle_pastaShells1": "media/animations/ParticlesAndSpritesheets/particle_pastaShells1.png",
            "particle_pastaShells2": "media/animations/ParticlesAndSpritesheets/particle_pastaShells2.png",
            "particle_pintoBeans": "media/animations/ParticlesAndSpritesheets/particle_pintoBeans.png",

            "particle_pepper": "media/animations/ParticlesAndSpritesheets/particle_pepper.png",
            "particle_salt": "media/animations/ParticlesAndSpritesheets/particle_salt.png",

            // myplate
            "myplatewood_background": "media/myplate_interface/wood_background-min.png",

            // "myplate_home_text":"media/myplate_interface/2x/myplate_home_text_2x-min.png",
            // "myplate_home_logo":"media/myplate_interface/2x/myplate_home_logo_2x-min.png",
            // "myplate_home_background":"media/myplate_interface/2x/myplate_home_background_2x-min.png",
            // "myplate_home_plate":"media/myplate_interface/2x/myplate_home_plate_2x-min.png",
            // "myplate_home_continue":"media/myplate_interface/2x/myplate_home_continue_2x-min.png",

            // "myplate_dairy_hover": "media/myplate_interface/2x/myplate_dairy_hover_2x-min.png",
            // "myplate_fruits_hover": "media/myplate_interface/2x/myplate_fruits_hover_2x-min.png",
            // "myplate_protein_hover": "media/myplate_interface/2x/myplate_protein_hover_2x-min.png",
            // "myplate_grains_hover": "media/myplate_interface/2x/myplate_grains_hover_2x-min.png",
            // "myplate_veggies_hover": "media/myplate_interface/2x/myplate_veggies_hover_2x-min.png",

            // "myplate_dairy_resting":"media/myplate_interface/2x/myplate_dairy_resting_2x-min.png",
            // "myplate_protein_resting": "media/myplate_interface/2x/myplate_protein_resting_2x-min.png",
            // "myplate_grains_resting": "media/myplate_interface/2x/myplate_grains_resting_2x-min.png",
            // "myplate_fruits_resting": "media/myplate_interface/2x/myplate_fruits_resting_2x-min.png",
            // "myplate_veggies_resting": "media/myplate_interface/2x/myplate_veggies_resting_2x-min.png",

            //plate
            "myplate_notext": "media/myplate_interface/myplate_notext_fruits_veggies-min.png",
            "myplate_notext_grains": "media/myplate_interface/myplate_notext_grains-min.png",
            "myplate_notext_protein": "media/myplate_interface/myplate_notext_protein-min.png",
            "myplate_notext_dairy": "media/myplate_interface/myplate_notext_dairy-min.png",

            //plate text
            "tx_dairy_text": "media/myplate_interface/1x/tx_dairy_text-min.png",
            "tx_fruit_text": "media/myplate_interface/1x/tx_fruit_text-min.png",
            "tx_grains_text": "media/myplate_interface/1x/tx_grains_text-min.png",
            "tx_protein_text": "media/myplate_interface/1x/tx_protein_text-min.png",
            "tx_veggies_text": "media/myplate_interface/1x/tx_veggies_text-min.png",
            
            //dairy
            "dr_dairy_plate": "media/myplate_interface/1x/dr_dairy_plate-min.png",

            //fruits & veggies
            "fv_cabbage_plate": "media/myplate_interface/1x/fv_cabbage_plate-min.png",
            "fv_carrots_plate": "media/myplate_interface/1x/fv_carrots_plate-min.png",
            "fv_celery_plate": "media/myplate_interface/1x/fv_celery_plate-min.png",
            "fv_greenbeans_plate": "media/myplate_interface/1x/fv_greenbeans_plate-min.png",
            "fv_tomato_plate": "media/myplate_interface/1x/fv_tomato_plate-min.png",
            "fv_yellowOnions_plate": "media/myplate_interface/1x/fv_yellowOnions_plate-min.png",
            "fv_zucchini_plate": "media/myplate_interface/1x/fv_zucchini_plate-min.png",
            
            //grains
            "gr_ditalini_plate": "media/myplate_interface/1x/gr_ditalini_plate-min.png",
            "gr_macaroni_plate": "media/myplate_interface/1x/gr_macaroni_plate-min.png",
            "gr_shells_plate": "media/myplate_interface/1x/gr_shells_plate-min.png",
            
            //protein
            "pr_cannellinibeans_plate": "media/myplate_interface/1x/pr_cannellinibeans_plate-min.png",
            "pr_lima_beans_plate": "media/myplate_interface/1x/pr_lima_beans_plate-min.png",
            "pr_pintobeans_plate": "media/myplate_interface/1x/pr_pintobeans_plate-min.png",
        },
        "animations": {
        },
    }
};